import { render, staticRenderFns } from "./AnnounceDetail.vue?vue&type=template&id=d95256cc&scoped=true&"
import script from "./AnnounceDetail.vue?vue&type=script&lang=js&"
export * from "./AnnounceDetail.vue?vue&type=script&lang=js&"
import style0 from "./AnnounceDetail.vue?vue&type=style&index=0&id=d95256cc&prod&lang=css&"
import style1 from "./AnnounceDetail.vue?vue&type=style&index=1&id=d95256cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95256cc",
  null
  
)

export default component.exports